import { ulid } from "ulid";
import { IGroup } from "../common/IGroup.intf";
import { createDefultTriggerAction, ITriggerAction } from "../trigger-action/ITriggerAction.intf";
import { mergeToDefaultData } from "../utils/mergeToDefaultData";
export const triggerActionGroupType = 'triggerActionGroup'
export interface ITriggerActionGroup extends IGroup<ITriggerAction>{
    type:string
    id:string
    name:string
}

export function createDefultTriggerActionGroup():ITriggerActionGroup{
    return {
        type:triggerActionGroupType,
        id:ulid(),
        name:'',
        list:[createDefultTriggerAction()],
        checks:[[true]],
        isSequential:true
    }
}

export function mergeTriggerActionGroupToDefultData(data:Partial<ITriggerActionGroup>):ITriggerActionGroup{
    return mergeToDefaultData(createDefultTriggerActionGroup, data)
}